const setupIsotope = function() {
  $('.grid').isotope({
    itemSelector: '.grid-item',
  });
}

export default setupIsotope;


// WEBPACK FOOTER //
// ./scripts/util/setupIsotope.js